import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { adminCopy } from '@/lib/copy';

import { clientsService } from '../services';
import type { UpdateClientPhiInput } from '../types';

import { clientsKeys } from './useClients';

export function useUpdatePhi(id: string, options?: { silent?: boolean }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateClientPhiInput) => clientsService.updatePhi(id, input),
    onSuccess: async (client) => {
      qc.setQueryData(clientsKeys.detail(id), client);
      // Drop the PHI cache entry so the next reveal hits BE (and audit-logs again).
      await qc.invalidateQueries({ queryKey: clientsKeys.operation('phi', id) });
      // Silent for callers with their own client-voiced toast (the Profile
      // screen), so its "Profile updated." isn't stacked with the admin copy.
      if (!options?.silent) toast.success(adminCopy.clients.sensitive.updatedToast);
    },
  });
}
